const initialState = {
  auth: {
    jwt: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTE2NDkxMDksImlkIjoiOTQ1MDQ3Iiwic2l0ZV9pZCI6IjQxIn0.6f37inUcDrcGDk0G_XdpMhhSORB2yH7hFdz9-0tBzWM",
  },
};

export default function application(state = initialState, action: any) {
  switch (action.type) {
    default:
      return state;
  }
}
